import { Collapsible } from '../interfaces';
import { Country } from './country';
import { Container } from './container';
import { CurrencyConversion } from './currency-conversion';

export class UncontrolledEntity implements Collapsible {
  entityId: number;
  name: string;
  code: string;
  description: string;
  domicile: Country = new Country();
  container: Container = new Container();
  legalEntityCurrencyConversion?: CurrencyConversion;
  collapsed: boolean;
}
